import styled, { css } from 'styled-components'

const Container = styled.div`
  width: 100vw;
  align-self: center;
  margin-bottom: 40px;
  background-color: ${props => props.theme.color.monochrome.lighter};
  padding-top: 16px;
  padding-bottom: 24px;

  ${props => css`
    @media only screen and (min-width: ${props.theme.size.breakpoint['min-width'].lg}) {
      padding-top: 40px;
    }
  `}
`

const HandcraftedToYourNeeds = styled.div`
  @media (max-width: ${props => props.theme.size.breakpoint['max-width'].sm}) {
    && [data-testid='c006-container'] {
      grid-template-columns: 1fr;
    }
  }
  && > * {
    background-color: inherit;
  }
`

export { Container, HandcraftedToYourNeeds }
